import { render, staticRenderFns } from "./medicineTopics.vue?vue&type=template&id=3c22d0e2"
import script from "./medicineTopics.vue?vue&type=script&lang=js"
export * from "./medicineTopics.vue?vue&type=script&lang=js"
import style0 from "./medicineTopics.vue?vue&type=style&index=0&id=3c22d0e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports